
// reactstrap components
import {
  Badge,
  Card,
  CardHeader,
  CardFooter,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  Media,
  Pagination,
  PaginationItem,
  PaginationLink,
  Progress,
  Table,
  Container,
  Row,
  UncontrolledTooltip
} from "reactstrap";
// core components
import Header from "components/Headers/Header.js";
import { useAccount } from "flow/flowContext";
import { useEffect, useState } from "react";
import { getAccountData } from "flow/scripts/account";
import KeysManagerHeader from "components/Headers/KeysManagerHeader";
import { revokeKeyFromAccount } from "flow/transactions/account";
import { useSearchParams } from "react-router-dom";
import { ACCESS_TOKEN_URL } from "config/apiUrls";
import axios from "axios";
import { addKeyToAccount } from "flow/transactions/account";

const KeysManager = () => {

  const { address, isConnected, disconnect, connect } = useAccount();
  const [accountData, setAccountData] = useState(null);


  const fetchAccountData = async () =>{
    const accountData = await getAccountData(address)
    setAccountData(accountData)
  }

  const handleSocialRecovery = async (code) =>{
    axios.get(ACCESS_TOKEN_URL+ "?code=" + code)
        }

  const [search, setSearch] = useSearchParams();

  useEffect(() => {
    fetchAccountData()

    const code = search.get('code');
    if (code) {
      handleSocialRecovery(code)
    }
  }, [])



  return (
    <>
      <KeysManagerHeader accountData={accountData}/>
      {/* Page content */}
      <Container className="mt--7" fluid>
        {/* Table */}
        <Row>
          <div className="col">
            <Card className="shadow" >
              <CardHeader className="border-0">
                <h3 className="mb-0">Active Keys</h3>
              </CardHeader>
              <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                  <tr>
                    <th scope="col">Public Key</th>
                    <th scope="col">index</th>
                    <th scope="col">Type </th>
                    <th scope="col">Hash Type</th>
                    <th scope="col">weight</th>
                    <th scope="col">Action</th>
                  </tr>
                </thead>
                <tbody>
                {accountData && accountData.keys.activeKeys.map((key) =>{
                      return(
                        <>
                        <tr>
                    <th scope="row">
                      <Media className="align-items-center">
                      
                        <Media>
                          <span className="mb-0 text-sm">
                          {key.publicKey.substring(0,10)}...{key.publicKey.substring(key.publicKey.length-10)}
                          </span>
                        </Media>
                      </Media>
                    </th>
                    <td>{key.index}</td>
                    <td>
                        {key.signAlgoString}
                    </td>
                    <td>
                        {key.hashAlgoString}
                    </td>    
                    <td>
                        {key.weight} / 1000
                    </td>  
                    <td className="text-left">
                      <UncontrolledDropdown>
                        <DropdownToggle
                          className="btn-icon-only text-light"
                          href="#pablo"
                          role="button"
                          size="sm"
                          color=""
                          onClick={(e) => e.preventDefault()}
                        >
                        <i className="fas fa-ellipsis-v" />
                        </DropdownToggle>
                        <DropdownMenu className="dropdown-menu-arrow" right>
                          <DropdownItem
                            href="#pablo"
                            onClick={(e) => {
                              e.preventDefault()
                              revokeKeyFromAccount(key.index)
                            }}
                          >
                            Revoke Key
                          </DropdownItem>
                          <DropdownItem
                            href="#pablo"
                            onClick={(e) => e.preventDefault()}
                          >
                            Update Key
                          </DropdownItem>
                          
                        </DropdownMenu>
                      </UncontrolledDropdown>
                    </td>
                  </tr>
                        </>
                      )
                    })}

                  
                  
                </tbody>
              </Table>
            </Card>
          </div>
        </Row>
        {/* Dark table */}
        <Row className="mt-5">
          <div className="col">
            <Card className="bg-default shadow">
              <CardHeader className="bg-transparent border-0">
                <h3 className="text-white mb-0">Revoked Keys</h3>
              </CardHeader>
              <Table
                className="align-items-center table-dark table-flush"
                responsive
              >
                <thead className="thead-dark">
                <tr>
                    <th scope="col">Public Key</th>
                    <th scope="col">index</th>
                    <th scope="col">Type </th>
                    <th scope="col">Hash Type</th>
                    <th scope="col">weight</th>
                  </tr>
                </thead>
                <tbody>
                {accountData && accountData.keys.revokedKeys.map((key) =>{
                      return(
                        <>
                        <tr>
                    <th scope="row">
                      <Media className="align-items-center">
                      
                        <Media>
                          <span className="mb-0 text-sm">
                          {key.publicKey.substring(0,10)}...{key.publicKey.substring(key.publicKey.length-10)}
                          </span>
                        </Media>
                      </Media>
                    </th>
                    <td>{key.index}</td>
                    <td>
                        {key.signAlgoString}
                    </td>
                    <td>
                        {key.hashAlgoString}
                    </td>    
                    <td>
                        {key.weight} / 1000
                    </td>  
                    
                  </tr>
                        </>
                      )
                    })}

                  
                  
                </tbody>
              </Table>
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default KeysManager;
